import { useEffect, useRef, useState } from "react";

export function useRowHighlightTracking() {
  const [highlightedIds, setHighlightedIds] = useState(() => {
    const raw = localStorage.getItem("openEditTabs");
    return raw ? JSON.parse(raw) : {};
  });

  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    const bc = new BroadcastChannel("editTabs");

    const onMessage = (event) => {
      if (isMounted.current) {
        setHighlightedIds(event.data || {});
      }
    };

    bc.addEventListener("message", onMessage);

    return () => {
      isMounted.current = false;
      bc.removeEventListener("message", onMessage);
      bc.close();
    };
  }, []);

  return highlightedIds;
}
